// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

import {
  Navbar,
  NavItem,
  NavLink,
} from 'reactstrap'

const ImageBase = styled.img`
  display: block;
  height: auto;
`

export const LogoImage = styled(ImageBase)`
  margin: .25em .5em;
`

export const NavbarWrapper = styled(Navbar)`
  align-items: center;
  box-shadow: 0 -.5em .5em .5em;
  flex-wrap: wrap;
`

export const NavbarButtons = styled.div`
  align-items: center;
  display: flex;
  width: ${props => props.isSignedIn ? '100%' : 'auto'};

  // md size in bootstrap
  @media (min-width: 768px) {
    margin-right: 1em;
    width: auto;
  }
`

// generic wrapper that's used for the navigation items as well as the feedback button.
export const NavLinkWrapper = styled(NavLink)`
  color: inherit;
  margin-left: auto;
  white-space: nowrap;

  &:hover {
    color: inherit;
  }
`

export const NavItemWrapper = styled(NavItem)`
  // adds a simple vertical spacer between items on larger views
  // md size in bootstrap
  @media (min-width: 768px) {
    display: flex;

    & + &::before {
      content: '|';
      display: block;
      margin: .5em .25em;
    }
  }

  // gives border-bottom styles on hover for navigation items in the header
  > ${NavLinkWrapper} {
    border-bottom: medium solid transparent;
    transition: .3s ease border-bottom-color;

    &:hover {
      // $blue in SCSS, aka primary color in bootstrap SCSS.
      border-bottom-color: #335c84;
      border-bottom-color: var(--primary);
    }
  }
`

export const NavbarAside = styled.aside`
  align-items: center;
  display: flex;
  margin-left: auto;
`

export const UserInfoWrapper = styled.div`
  // targets the wrapping element around Amplify's component.
  > div > div {
    border-width: 0;
    border-left-width: thin;
    white-space: nowrap;

    // I know, I know... I don't like it either...
    & > div {
      padding: 0;
      padding-left: .5em;
    }
  }

  // the default min-width is way too big.
  button[data-test="sign-out-button"] {
    min-width: 80px;
    padding-bottom: .5em;
    padding-top: .5em;
  }
`
